import {
    ExtendedFieldId,
    Validator,
    ExtendedErrorId,
    setCustomValidator,
    FieldContent,
} from '@sheerid/jslib';

const DECIMAL_RADIX = 10;
const MIN_GRADYEAR = new Date().getFullYear();
const MIN_GRADMONTH = new Date().getMonth();
const MAX_GRADYEAR = MIN_GRADYEAR + 11;

export const gradDateValidator = () => {
    const gradDate: ExtendedFieldId = 'graduation-date';

    const getGradDateValidationError: Validator = (value: FieldContent): ExtendedErrorId => {
        const invalidError: ExtendedErrorId = 'invalidGradDate';

        const dateParts = value.toString().split('/');
        const dateMonth = parseInt(dateParts[0], DECIMAL_RADIX);
        const dateYear = parseInt(dateParts[1], DECIMAL_RADIX);

        if (dateYear < MIN_GRADYEAR || dateYear > MAX_GRADYEAR || dateMonth < 0 || dateMonth > 12) {
            return invalidError;
        }

        // check for earlier than current month in the same year
        if (dateYear === MIN_GRADYEAR && dateMonth <= MIN_GRADMONTH) {
            return invalidError;
        }

        if ((!dateMonth && !dateYear) || Number.isNaN(dateMonth) || Number.isNaN(dateYear)) {
            return invalidError;
        }

        return;
    };

    setCustomValidator(gradDate, getGradDateValidationError);
};
